import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
export function FloatingCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-96">
      {show && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden p-3 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]" data-id="element-97">
          <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="block w-full py-4 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-lg rounded-full text-center shadow-lg" data-id="element-98">
            🔥 QUIERO MI MEGAPACK
          </a>
        </motion.div>}
    </AnimatePresence>;
}